import axiosInstance from "./axios";

export const uploadFile = async (data) => {
  const response = await axiosInstance.postForm(`/api/v1/upload/`, data);

  return response;
};
